import React, { useMemo } from 'react';
import {
  Box,
  Controller,
  FieldWrapper,
  Label,
  OptionKey,
  Text,
  useFormContext,
  useWatch,
} from '@common-fe/common-fe';

import { ADD_CONTACT_ID, EDIT_CONTACT_ID, IRoleSetup } from '../../role.types';
import { AllowRolesDropdown } from '../RoleSetupForm/BasicProperties/AllowCreateAnotherRole';

interface Props {
  isEditMode?: boolean;
}
const AllowContactCreateRole: React.FC<Props> = ({ isEditMode = false }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext<IRoleSetup>();
  const permissions: OptionKey[] = useWatch({
    control,
    name: 'permissions',
  });

  const isDisplayed = useMemo(() => {
    if (permissions.includes(ADD_CONTACT_ID) || permissions.includes(EDIT_CONTACT_ID)) {
      return true;
    }
    return false;
  }, [permissions]);
  if (!isDisplayed) {
    return null;
  }
  return (
    <FieldWrapper align="start" margin={{ top: 'm' }}>
      <Box direction="row" height={{ min: '40px' }} align="start">
        <Box direction="column" width={{ max: '300px' }}>
          <Label showRequireIcon={true} name="role-contact-ids">
            Allow creating contacts
          </Label>
          <Text size="small" color="textSecondary" style={{ lineHeight: '18px' }}>
            Select roles that a contact with this role can create. This feature is available when either "Add
            contacts" or "Edit contacts" is enabled.
          </Text>
        </Box>
        <Box width="medium">
          <Controller
            name="allowedForContactsByRoleId"
            control={control}
            render={({ field }) => {
              return (
                <AllowRolesDropdown
                  errorText={errors?.allowedForContactsByRoleId?.message}
                  isEditMode={true}
                  onChangeValues={field.onChange}
                  values={field.value}
                />
              );
            }}
          />
        </Box>
      </Box>
    </FieldWrapper>
  );
};

export default AllowContactCreateRole;
